class CustomDropdown {

    constructor (element) {
        if (!(element instanceof HTMLElement)) {
            throw new TypeError('CustomDropdown Invalid Element');
        }

        this.container = element;
        this.container.hasSiblingFilter = this.container.parentElement.parentElement.querySelectorAll('.custom-dropdown').length > 1;

        // event to open dropdown
        this.container.querySelector('.dropdown-label').addEventListener('click', event => {
            event.currentTarget.parentElement.classList.toggle('open');
        });

        this.container.addEventListener('mouseleave', event => {
            event.currentTarget.classList.toggle('open', false);
        });

        this.container.options = this.container.querySelectorAll('.dropdown-option > input');
        this.container.options.forEach(option => {

            option.timeout = null;

            option.addEventListener('change', event => {
                var url = new URL(`${window.location.origin}/news`);

                // if sibling filter
                if (this.container.hasSiblingFilter) {
                    this.container.parentElement.parentElement.querySelectorAll('.custom-dropdown').forEach( filter => {
                        let checked = new Array();

                        filter.querySelectorAll('.dropdown-option > input').forEach(function(option) {
                            if (option.checked) checked.push(option.value);
                        });

                        url.searchParams.set(filter.dataset.taxonomy, checked);
                    });
                } else {
                    var checked = new Array();
                    this.container.options.forEach(function(option) {
                        if (option.checked) checked.push(option.value);
                    });
    
                    url.searchParams.set(this.container.dataset.taxonomy, checked);
                }

                event.target.timeout = setTimeout( () => {
                    window.location = url.href;
                }, 800);
            });
        });
    }
}

export default CustomDropdown;
